//////////////////
// IMPORTS
//////////////////
// libraries
import * as React from "react";
import { connect } from "react-redux";
import { createFragmentContainer } from "react-relay";
// suggestion-action-reschedule imports
import { IContainer, IProps } from "./SuggestionActionReschedule.d";
import { fragments } from "./SuggestionActionReschedule.gql";
import { CardButton } from "@components/card";
import {
  makeEventReschedulerViewActive,
  updateSchedulingSessionId,
} from "@actions/feed-scheduler.actions";
import { IReduxState } from "@reducers/root.reducer";
import { track, TrackingEvents } from "@util/analytics.util";
import { createUUID } from "@clockwise/client-commons/src/util/uuid";
// material-ui
import { ArrowForward } from "@material-ui/icons";

//////////////////
// COMPONENT
//////////////////
class SuggestionActionRescheduleCmpt extends React.Component<IProps> {
  private rescheduleMeeting = () => {
    const { actionCallback, payload } = this.props;
    const { event } = payload;

    if (actionCallback) {
      // should this logic should be elsewhere?
      const schedulingSessionId = createUUID();
      this.props.updateSchedulingSessionId(schedulingSessionId);
      track(TrackingEvents.SCHEDULING.RESCHEDULER_STARTED, {
        schedulingSessionId,
        externalEventId: event.eventKey.externalEventId,
      });
      this.props.makeEventReschedulerViewActive(event);

      actionCallback();
    }
  };

  public render() {
    const { label } = this.props;
    return (
      <CardButton flat icon={<ArrowForward />} onClick={this.rescheduleMeeting} label={label} />
    );
  }
}

//////////////////
// REDUX
//////////////////
function mapStateToProps(_state: IReduxState, _ownProps: IContainer) {
  return {};
}

const SuggestionActionRescheduleRedux = connect(mapStateToProps, {
  makeEventReschedulerViewActive,
  updateSchedulingSessionId,
})(SuggestionActionRescheduleCmpt);

//////////////////
// RELAY
//////////////////
export const SuggestionActionReschedule = createFragmentContainer<IContainer>(
  SuggestionActionRescheduleRedux,
  fragments,
);
